import { Reducer } from 'redux';
import { CriarAtendimentoState, CriarAtendimentoTypes } from './types';

const INITIAL_STATE: CriarAtendimentoState = {
  notas: [],
  protocolo: 0,
  error: false,
  loading: false,
  filter: undefined,
  pagination: {
    total: 0,
    pageSize: 5,
    current: 1,
    showSizeChanger: true,
    pageSizeOptions: ['5', '10', '20', '50'],
  },
};

const reducer: Reducer<CriarAtendimentoState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CriarAtendimentoTypes.LOAD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case CriarAtendimentoTypes.LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        notas: action.payload.notas,
        pagination: action.payload.pagination,
      };
    case CriarAtendimentoTypes.LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        notas: [],
      };
    case CriarAtendimentoTypes.FILTER_NOTAS:
      return {
        ...state,
        filter: action.payload.filter,
      };
    case CriarAtendimentoTypes.CLEAN_NOTAS:
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default reducer;
